export const heatMapChartOptionsProp = (dates, groups) => {
  return {
    animation: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    },
    scales: {
      x: {
        grid: { display: false },
        labels: dates,
        type: 'category'
      },
      y: {
        grid: { display: false },
        labels: groups,
        offset: true,
        ticks: { display: true },
        type: 'category'
      }
    }
  }
}
